__turbopack_context__.v({
  "body": "vcpqOq_body",
  "heading": "vcpqOq_heading",
  "root": "vcpqOq_root",
  "subheading": "vcpqOq_subheading",
});
